import(/* webpackMode: "eager" */ "/app/app/query/page.tsx");
